// third-party
import { createSlice } from "@reduxjs/toolkit";

// project imports
import axios from "utils/axios";

// ----------------------------------------------------------------------

const initialState = {
  error: null,
  authData: {},
};

const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
    },

    loginSuccess(state, action) {
      state.authData = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;
export const { hasError, loginSuccess } = slice.actions;

// ----------------------------------------------------------------------
export function login(payload) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/token', payload);
      dispatch(loginSuccess(response.data));
      return response;
    } catch (error) {
      dispatch(hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------
export function changePassword(payload) {
  return async (dispatch) => {
    try {
      const userName = localStorage.getItem("userName")
      const response = await axios.post(`/users/${userName}/password`, payload);
      return response.data;
    } catch (error) {
      dispatch(hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------
// ✅ Verify OTP for Login
export function verifyLoginOTP(username, otp) {
  return async (dispatch) => {
    try {
      // Use /token/verify-otp endpoint for login OTP verification
      // Send username and OTP as URL-encoded form data (application/x-www-form-urlencoded)
      const params = new URLSearchParams();
      params.append('username', username);
      params.append('otp', otp);
      
      // Create a request without Authorization header by temporarily removing token
      const originalToken = localStorage.getItem('ucla-token');
      if (originalToken) {
        localStorage.removeItem('ucla-token');
      }
      
      try {
        const response = await axios.post('/token/verify-otp', params.toString(), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        });
        dispatch(loginSuccess(response.data));
        return response;
      } finally {
        // Restore original token if it existed
        if (originalToken) {
          localStorage.setItem('ucla-token', originalToken);
        }
      }
    } catch (error) {
      dispatch(hasError(error));
      throw error;
    }
  };
}